export type DeliveryType = 'SMD' | 'SPT' | 'CO2F' | '99M' | 'RET' | 'NAL' | 'ECO' | 'TLM' | 'XBD';

export enum Platform {
  // Plataformas internas
  API_V1 = 'api-v1',
  API_V3 = 'api-v3',
  HubPlatform = 'hub-platform',
  MassiveLoad = 'massive-load',
  Fulfill99 = 'fulfill99',

  // Plataformas externas
  Shopify = 'shopify',
  TikTok = 'tiktok',
  WooCommerce = 'woo-commerce',
  Magento = 'magento',
  TiendaNube = 'tienda-nube',
  JumpSeller = 'jumpseller',
  BigCommerce = 'big-commerce',
  MeliFlex = 'meli-flex',

  // Fallback
  Unknown = 'UNKNOWN',
}

export type StatusFilter =
  | 'draft'
  | 'confirmed'
  | 'readyToPickup'
  | 'onPickup'
  | 'stored'
  | 'onP99'
  | 'onRoadToDelivery'
  | 'incident'
  | 'onReview'
  | 'delivered'
  | 'returned'
  | 'cancelled';

type Sizes = 'xs' | 's' | 'm' | 'l' | 'xl';

export interface IReqOrders {
  page?: number;
  pageSize?: number;
  deliveryType?: DeliveryType;
  search?: string;
  statusFilter?: StatusFilter;
  startDate?: string;
  endDate?: string;
}

export interface IResOrdersData {
  ordersData: OrdersData[];
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface OrdersData {
  additional: Additional;
  createdAt: string;
  deliveryType: DeliveryType;
  destination: Address;
  expiresAt: string;
  internalKey: string;
  origin: Address;
  platform?: Platform;
  recipient: Person;
  sender: Person;
  size: Sizes;
  status: string;
  statusNameEN: string;
  statusNameES: string;
  trackingId: string;
  updatedAt: string;
}

interface Additional {
  cashOnDelivery: number;
  draft: boolean;
  ecoTag: boolean;
  insured: number;
  notes: string;
  orderPrice: number;
  pickupAfter: string;
}

export interface Address {
  address: string;
  country: string;
  lat: number;
  lng: number;
  references: string;
  station: string;
  type: string;
  zipCode: string;
  zone: string;
}

export interface Person {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

// ------- Responses

interface IResOrders<T> {
  code: number;
  data: T;
  message: string;
  success: boolean;
  traceId: string;
}

interface ErrorData {
  error: string;
  failedField: string;
  tag: string;
  value: string;
}

export type IResOrdersOK = IResOrders<IResOrdersData>;
export type IResOrdersError = IResOrders<ErrorData[]>;
export type IResOrdersUnauthorized = Omit<IResOrders<string>, 'data'>;
